/**
 * Login / induction email tracking — Sent (dispatched) vs Received (signed in).
 */

import { COACH_ROLES, COMMITTEE_ROLES } from './clubRoles';
import type { InductionPersona } from './inductionEmail';

export type InductionLoginState = 'not_sent' | 'sent_waiting' | 'signed_in';

export type InductionLoginAudience = 'committee' | 'families' | 'all';

export function isStaffInductionRoles(roles: readonly string[]): boolean {
  return roles.some(
    (r) =>
      (COMMITTEE_ROLES as readonly string[]).includes(r) ||
      (COACH_ROLES as readonly string[]).includes(r),
  );
}

export function inductionLoginState(opts: {
  sentAt?: string | null;
  firstSignedInAt?: string | null;
}): InductionLoginState {
  if (opts.firstSignedInAt) return 'signed_in';
  if (opts.sentAt) return 'sent_waiting';
  return 'not_sent';
}

export const INDUCTION_LOGIN_STATE_LABEL: Record<InductionLoginState, string> = {
  not_sent: 'Not sent',
  sent_waiting: 'Sent · waiting',
  signed_in: 'Received',
};

export const INDUCTION_LOGIN_AUDIENCE_LABEL: Record<InductionLoginAudience, string> = {
  committee: 'Committee & coaches',
  families: 'Parents & families',
  all: 'Everyone with an email',
};

export function inductionPersonaLabel(persona: InductionPersona | string | null | undefined): string {
  if (persona === 'staff') return 'Committee website';
  if (persona === 'parent') return 'Family phone app';
  return '—';
}

export type BatchInductionResult = {
  ok: true;
  attempted: number;
  sent: number;
  skipped: number;
  /** Swimmers who still hold a sign-in, so the batch did not email them. */
  skipped_child_logins?: number;
  failed: Array<{ user_id: string; email: string | null; error: string }>;
};
